
import { getActivity } from '@/common/js/api.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import VChart from 'vux/src/components/v-chart/v-chart.vue'
import VTooltip from 'vux/src/components/v-chart/v-tooltip.vue'
import VLine from 'vux/src/components/v-chart/v-line.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import VScale from 'vux/src/components/v-chart/v-scale.vue'


export default {
components: {
XHeader,
Box,
XButton,
Group,
CellBox,
Cell,
Scroller,
Icon,
VChart,
VTooltip,
VLine,
Flexbox,
FlexboxItem,
VScale
},
methods: {




appoint() {
this.$router.push({
path: '/',
query: { activityId: this.entity.activityId }
})
},
siteAppoint() {
this.$router.push({
path: '/activity/appointment',
query: { activityId: this.entity.activityId }
})
},
getActivity(activityId) {
let self = this
getActivity({ data: { activityId: activityId } }).then(function(data) {
self.entity = data.Content
document.title = self.entity.activityName
if (self.entity.activityType == 4) {
self.view.fieldText = '快递员上门回收'
}
if (self.entity.status != 1) {
self.appointAble = false
} else {
if (self.entity.expired) {
self.appointAble = false
} else self.appointAble = true
}
})
}
},
data() {
return {
entity: {},
appointAble: false,
view: {
fieldText: '现场回收'
}
}
},
created() {
let activityId = this.$route.query.activityId
this.getActivity(activityId)
}
}



// WEBPACK FOOTER //
// ./src/components/activity/Detail.vue